import { Injectable } from '@angular/core';
import { ResoursesService } from 'src/app/services/resourses.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ExamReason } from 'src/app/models/patientConsultation';
import { ApiResp } from '../models/apiResp';
import { environment } from '../../environments/environment';
import ApiRoutes from '../global/apiRoutes.routes';
import { catchError, map } from 'rxjs/operators';
import { examReasonRoutes } from '../global/apiRoutes.routes';

@Injectable({
  providedIn: 'root'
})
export class ExamReasonService {

  constructor(
    private resources: ResoursesService,
    private http: HttpClient
  ) { }

  public findAll(): Observable<ExamReason[]> {
    return this.http.get<ApiResp>(environment.apiUrl + ApiRoutes.getExamReasons(), { headers: this.resources.getHeaders() })
      .pipe(
        map(resp => resp.data),
        catchError(error => this.resources.handleError(error)));
  }

  public save(examReason: any): Observable<any> {
    return this.http.post<ApiResp>(environment.apiUrl + ApiRoutes.saveExamReason(), examReason, { headers: this.resources.getHeaders() })
      .pipe(
        map(resp => this.resources.handleResponse(resp)),
        catchError(error => this.resources.handleError(error)));
  }

  public delte(idExamReason: string): Observable<any> {
    return this.http.delete<ApiResp>(environment.apiUrl + examReasonRoutes.delete(idExamReason), { headers: this.resources.getHeaders() })
      .pipe(
        map(resp => this.resources.handleResponse(resp, null, null, 'Eliminado')),
        catchError(error => this.resources.handleError(error)));
  }
}
